function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
import { CoreVideoInternal } from '../../core-video-internal';
import { LogVerbose } from '../../decorators/log-verbose';
import { sdkLogger } from '../../logger';
import { Observable } from '../../utils/observables/observable';
import { SessionControllerPrecursorCache } from '../session-controller/precursor/session-controller-precursor-cache';
import { SessionControllerPrecursor } from '../session-controller/precursor/session-controller-precursor';
import { isRawSessionItem } from '../session-controller/session-controller';
import { InternalConfigProvider } from '../../config/internal-config-provider';
/**
 * @public
 */ export var PlayerController = /*#__PURE__*/ function() {
    "use strict";
    function PlayerController(engine, reinitialise, videoPlatformIntegration, propositionExtensions, engineCreationOptions, peiPrecursorEngine, hdcpManager) {
        _class_call_check(this, PlayerController);
        _define_property(this, "engine", void 0);
        _define_property(this, "reinitialise", void 0);
        _define_property(this, "videoPlatformIntegration", void 0);
        _define_property(this, "propositionExtensions", void 0);
        _define_property(this, "engineCreationOptions", void 0);
        _define_property(this, "peiPrecursorEngine", void 0);
        _define_property(this, "hdcpManager", void 0);
        _define_property(this, "currentSession", void 0);
        _define_property(this, "sessionCreatedObservable", void 0);
        _define_property(this, "playoutRect", void 0);
        _define_property(this, "isFullScreen", void 0);
        _define_property(this, "logger", void 0);
        this.engine = engine;
        this.reinitialise = reinitialise;
        this.videoPlatformIntegration = videoPlatformIntegration;
        this.propositionExtensions = propositionExtensions;
        this.engineCreationOptions = engineCreationOptions;
        this.peiPrecursorEngine = peiPrecursorEngine;
        this.hdcpManager = hdcpManager;
        this.sessionCreatedObservable = new Observable();
        this.logger = sdkLogger.withContext('PlayerController');
    }
    _create_class(PlayerController, [
        {
            key: "createSession",
            value: function createSession(sessionItem) {
                if (this.currentSession && !this.currentSession.isFinished()) {
                    throw new Error('ERROR.SESSION.START.PREVIOUS_SESSION');
                }
                this.createSessionAsync(sessionItem);
            }
        },
        {
            key: "onSessionCreated",
            value: function onSessionCreated(callback) {
                this.sessionCreatedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.currentSession) {
                    this.currentSession.stop();
                }
                this.sessionCreatedObservable.unregisterObservers(this);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.engine.getElement();
            }
        },
        {
            key: "disposeElement",
            value: function disposeElement() {
                this.engine.disposeElement();
            }
        },
        {
            key: "getPlayoutRect",
            value: function getPlayoutRect() {
                if (CoreVideoInternal.playerCapabilities.setPlayoutRect) {
                    return this.isFullScreen ? this.engine.getFullScreenPlayoutRect() : this.playoutRect;
                }
                if (CoreVideoInternal.playerCapabilities.getPlayoutRect) {
                    return this.engine.getFullScreenPlayoutRect();
                }
            }
        },
        {
            key: "setPlayoutRect",
            value: function setPlayoutRect(expressivePlayoutRect) {
                this.playoutRect = this.getFixedPlayoutRect(expressivePlayoutRect);
                this.handleSetPlayoutRect();
            }
        },
        {
            key: "setFullScreen",
            value: function setFullScreen(flag) {
                this.isFullScreen = flag;
                this.handleSetPlayoutRect();
            }
        },
        {
            key: "getCapabilities",
            value: function getCapabilities() {
                return CoreVideoInternal.playerCapabilities;
            }
        },
        {
            key: "createSessionAsync",
            value: function createSessionAsync(sessionItem) {
                var _this = this;
                return _async_to_generator(function() {
                    var configPerPlaybackType, config, currentPrecursor;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.reinitialise()
                                ];
                            case 1:
                                configPerPlaybackType = _state.sent();
                                config = InternalConfigProvider.getForPlaybackType(configPerPlaybackType, sessionItem.type);
                                currentPrecursor = _this.getSessionControllerPrecursor(config, sessionItem);
                                currentPrecursor.onSessionAttached(function(sessionController) {
                                    // This should only happen once per precursor instance
                                    _this.currentSession = sessionController;
                                    _this.sessionCreatedObservable.notifyObservers(sessionController);
                                });
                                currentPrecursor.startSession();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleSetPlayoutRect",
            value: function handleSetPlayoutRect() {
                if (CoreVideoInternal.playerCapabilities.setPlayoutRect) {
                    if (this.isFullScreen) {
                        var fullScreenRect = this.engine.getFullScreenPlayoutRect();
                        this.engine.setPlayoutRect(fullScreenRect);
                    } else {
                        this.engine.setPlayoutRect(this.playoutRect);
                    }
                }
            }
        },
        {
            key: "getFixedPlayoutRect",
            value: function getFixedPlayoutRect(expressivePlayoutRect) {
                var _this = this;
                if (CoreVideoInternal.playerCapabilities.getPlayoutRect) {
                    var fullScreenRect = this.engine.getFullScreenPlayoutRect();
                    if (fullScreenRect) {
                        var x = expressivePlayoutRect.x, y = expressivePlayoutRect.y, width = expressivePlayoutRect.width, height = expressivePlayoutRect.height;
                        var getValue = function(value, fullScreenRectValue) {
                            return Math.round(typeof value === 'number' ? value : _this.parsePercentage(value) * fullScreenRectValue);
                        };
                        return _object_spread_props(_object_spread({}, expressivePlayoutRect), {
                            x: getValue(x, fullScreenRect.width),
                            y: getValue(y, fullScreenRect.height),
                            width: getValue(width, fullScreenRect.width),
                            height: getValue(height, fullScreenRect.height)
                        });
                    }
                }
                return expressivePlayoutRect;
            }
        },
        {
            key: "parsePercentage",
            value: function parsePercentage(val) {
                var parsedValue = parseFloat(val);
                if (isNaN(parsedValue) || parsedValue > 100 || parsedValue < 0 || !val.endsWith('%')) {
                    throw new Error('Proportional PlayoutRect must be expressed as a percentage within the screen size (eg: "50%")');
                }
                return parsedValue / 100;
            }
        },
        {
            key: "getSessionControllerPrecursor",
            value: function getSessionControllerPrecursor(config, sessionItem) {
                if (!isRawSessionItem(sessionItem)) {
                    var precursor = SessionControllerPrecursorCache.getInstance().get(sessionItem.key, true);
                    if (precursor) {
                        this.logger.info("Using cached precursor for content ".concat(sessionItem.key));
                        if (!precursor.getPlayerEngine()) {
                            precursor.setPlayerEngine(this.engine);
                            precursor.bootstrapSession();
                        }
                        precursor.updateSessionItem(sessionItem);
                        return precursor;
                    }
                }
                return new SessionControllerPrecursor(this.videoPlatformIntegration, sessionItem, this.propositionExtensions.addonFactories, config, this.peiPrecursorEngine, this.engineCreationOptions, this.engine, this.hdcpManager);
            }
        }
    ]);
    return PlayerController;
}();
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof SessionItem === "undefined" ? Object : SessionItem
    ]),
    _ts_metadata("design:returntype", void 0)
], PlayerController.prototype, "createSession", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], PlayerController.prototype, "destroy", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", typeof JSX === "undefined" || typeof JSX.Element === "undefined" ? Object : JSX.Element)
], PlayerController.prototype, "getElement", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], PlayerController.prototype, "disposeElement", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Object)
], PlayerController.prototype, "getPlayoutRect", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof PlayoutRect === "undefined" ? Object : PlayoutRect
    ]),
    _ts_metadata("design:returntype", void 0)
], PlayerController.prototype, "setPlayoutRect", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Boolean
    ]),
    _ts_metadata("design:returntype", void 0)
], PlayerController.prototype, "setFullScreen", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", typeof PlayerCapabilities === "undefined" ? Object : PlayerCapabilities)
], PlayerController.prototype, "getCapabilities", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof SessionItem === "undefined" ? Object : SessionItem
    ]),
    _ts_metadata("design:returntype", Promise)
], PlayerController.prototype, "createSessionAsync", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], PlayerController.prototype, "handleSetPlayoutRect", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof PlayoutRect === "undefined" ? Object : PlayoutRect
    ]),
    _ts_metadata("design:returntype", typeof PlayoutRect === "undefined" ? Object : PlayoutRect)
], PlayerController.prototype, "getFixedPlayoutRect", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", Number)
], PlayerController.prototype, "parsePercentage", null);
_ts_decorate([
    LogVerbose(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof InternalConfig === "undefined" ? Object : InternalConfig,
        typeof SessionItem === "undefined" ? Object : SessionItem
    ]),
    _ts_metadata("design:returntype", typeof SessionControllerPrecursor === "undefined" ? Object : SessionControllerPrecursor)
], PlayerController.prototype, "getSessionControllerPrecursor", null);

//# sourceMappingURL=player-controller.js.map